import TeamSection from '../components/TeamSection/TeamSection';

function Team() {
  return <TeamSection />;
}

export default Team;
